export const julyUppercase = "era";
export default {julyUppercase};